import type { ReactNode } from 'react';

import type { VNFieldHelpProps } from './types';
import { hasClickableFieldHelp, hasFieldHelpIcon } from './types';
import { useVNFieldHelpController } from './useVNFieldHelpController';
import VNFieldHelpChrome from './VNFieldHelpChrome';
import VNFieldHelpIconButton from './VNFieldHelpIconButton';

type Props = VNFieldHelpProps & {
  title: ReactNode;
  className?: string;
};

const VNFieldHelpHeading = ({ title, className, ...fieldHelpProps }: Props) => {
  const showIcon = hasFieldHelpIcon(fieldHelpProps);
  const {
    containerRef,
    panelOpen,
    drawerOpen,
    isActive,
    clickable,
    handleIconClick,
    handleOpenDrawerFromPanel,
    drawerAriaLabel,
    closeDrawer,
    helperTooltip,
    helperText,
    helperContent,
    helperLink,
    helperContentTitle,
  } = useVNFieldHelpController(fieldHelpProps);

  if (!showIcon) {
    return title;
  }

  const rootClass = ['vn-field-help', 'vn-field-help--heading', panelOpen && 'vn-field-help--help-open', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClass} ref={containerRef}>
      <span className="vn-field-help__label vn-field-help__label--inline">
        <span>{title}</span>
        <VNFieldHelpIconButton
          active={isActive}
          helperTooltip={helperTooltip}
          onClick={hasClickableFieldHelp(fieldHelpProps) ? handleIconClick : undefined}
          ariaLabel={drawerAriaLabel}
        />
      </span>
      <VNFieldHelpChrome
        panelOpen={panelOpen}
        drawerOpen={drawerOpen}
        helperText={helperText}
        helperLink={helperLink}
        helperContent={helperContent}
        helperContentTitle={helperContentTitle}
        onOpenDrawerFromPanel={handleOpenDrawerFromPanel}
        onCloseDrawer={closeDrawer}
      />
    </div>
  );
};

export default VNFieldHelpHeading;
